import { render, staticRenderFns } from "./SelectObjectAutocomplete.vue?vue&type=template&id=60818253&scoped=true&"
import script from "./SelectObjectAutocomplete.vue?vue&type=script&lang=js&"
export * from "./SelectObjectAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60818253",
  null
  
)

export default component.exports